
export function deleteLegalRepresentative(legalRepresentativeRepository, legalRepresentativeId) {
  return legalRepresentativeRepository.delete(legalRepresentativeId);
}
